import React from "react";

export default function CountriesWithSubmissionStatus({
  participatingCountries = [],
  countriesWithSubmissions = [],
  countriesWithData = [],
  loading = false,
}) {
  if (loading) {
    return (
      <fieldset className="rounded-2xl border-2 border-[#E5E7EB] bg-white p-4 shadow-sm">
        <legend className="ml-2 px-2 text-xs font-semibold uppercase tracking-wide text-[#6B7280]">
          Countries/Regions
        </legend>
        <div className="mt-2 text-sm text-[#6B7280] animate-pulse">Loading...</div>
      </fieldset>
    );
  }

  if (participatingCountries.length === 0) {
    return (
      <fieldset className="rounded-2xl border-2 border-[#E5E7EB] bg-white p-4 shadow-sm">
        <legend className="ml-2 px-2 text-xs font-semibold uppercase tracking-wide text-[#6B7280]">
          Countries/Regions
        </legend>
        <div className="mt-2 text-sm text-[#6B7280]">—</div>
      </fieldset>
    );
  }

  // Normalize country names for case-insensitive comparison
  const normalizeCountry = (country) => String(country || "").toUpperCase().trim();
  const dataSet = new Set(countriesWithData.map(normalizeCountry));
  const submissionsSet = new Set(countriesWithSubmissions.map(normalizeCountry));

  return (
    <fieldset className="rounded-2xl border-2 border-[#E5E7EB] bg-white p-4 shadow-sm">
      <legend className="ml-2 px-2 text-xs font-semibold uppercase tracking-wide text-[#6B7280]">
        Countries/Regions
      </legend>
      <div className="mt-3 flex flex-wrap gap-2">
        {participatingCountries.map((country) => {
          const normalizedCountry = normalizeCountry(country);
          const hasData = dataSet.has(normalizedCountry);
          const hasSubmission = submissionsSet.has(normalizedCountry);

          let bgColor, textColor, tooltipText, statusIcon;

          if (hasData) {
            // Green: Has data in indicators_scenathon and trade_scenathon
            bgColor = "bg-green-50 border-green-200";
            textColor = "text-green-800 font-semibold";
            tooltipText = "Data submitted and processed";
            statusIcon = "✓";
          } else if (hasSubmission) {
            // Orange: Has submission but not yet in tables
            bgColor = "bg-amber-50 border-amber-200";
            textColor = "text-amber-800 font-semibold";
            tooltipText = "Submission received, processing...";
            statusIcon = "⏳";
          } else {
            // Red: No data or submissions
            bgColor = "bg-red-50 border-red-200";
            textColor = "text-red-800 font-semibold";
            tooltipText = "No submissions yet";
            statusIcon = "✗";
          }

          return (
            <div
              key={country}
              className={`px-3 py-2 rounded-lg border-2 text-sm font-medium ${bgColor} ${textColor} cursor-help`}
              title={tooltipText}
            >
              {country}
              <span className="ml-1">{statusIcon}</span>
            </div>
          );
        })}
      </div>
    </fieldset>
  );
}
